'use strict';

function alwaysValid() {
  return true;
}

module.exports = {
  alwaysValid: alwaysValid
};